import(/* webpackMode: "eager" */ "/vercel/path0/blockpage411/app/fundraisers/page.tsx");
